import { Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { isEmptyObject, awaitAllSafely } from '@vy/utils';
import type { FC } from 'react';
import type {
  HubSpotConfigurationControl,
  HubSpotConfigurationFormValues,
} from '../HubSpotConfigurationFormSchema';
import { useFetchHubSpotSettings } from '../hooks/useFetchHubSpotSettings';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';
import { useModifyHubSpotConfiguration } from '../hooks/useModifyHubSpotConfiguration';
import { getHubSpotIntegrationSettings } from './utils';

type HubSpotConfigurationFooterProps = {
  control: HubSpotConfigurationControl;
};

export const HubSpotConfigurationFooter: FC<HubSpotConfigurationFooterProps> = () => {
  const { integrationId, configuration: existingConfiguration } = useFetchHubSpotSettings();
  const updateHubSpotConfiguration = useModifyHubSpotConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<HubSpotConfigurationFormValues>();

  const getUpdateHubSpotConfigurationPromise = async (formValues: HubSpotConfigurationFormValues) => {
    if (isEmptyObject(dirtyFields)) {
      return undefined;
    }

    const existingIntegrationSettings = getHubSpotIntegrationSettings(existingConfiguration);
    const updatedIntegrationSettings = getHubSpotIntegrationSettings(formValues);

    return updateHubSpotConfiguration(integrationId, updatedIntegrationSettings, existingIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    const updateHubSpotConfigurationPromise = getUpdateHubSpotConfigurationPromise(formValues);

    await awaitAllSafely(updateHubSpotConfigurationPromise);

    reset(formValues);
    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Save Configuration
      </Button>
    </div>
  );
};
